export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  link: (slug) => `nav-link-${slug}`,
  ctaContact: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  ctaPrimary: "hero-cta-explore",
  ctaSecondary: "hero-cta-careers",
};

export const PRODUCTS = {
  section: "products-section",
  card: (slug) => `product-card-${slug}`,
};

export const CAREERS = {
  section: "careers-section",
  jobCard: (slug) => `job-card-${slug}`,
  applyBtn: (slug) => `job-apply-${slug}`,
  modal: "job-application-modal",
  inputName: "apply-input-name",
  inputEmail: "apply-input-email",
  inputPhone: "apply-input-phone",
  inputMessage: "apply-input-message",
  inputResume: "apply-input-resume",
  submitBtn: "apply-submit-btn",
};

export const REVIEWS = {
  section: "reviews-section",
  card: (i) => `review-card-${i}`,
  indeedLink: "reviews-indeed-link",
  glassdoorLink: "reviews-glassdoor-link",
};

export const CONTACT = {
  section: "contact-section",
  address: "contact-address",
  phone: "contact-phone",
  email: "contact-email",
};

export const FOOTER = {
  root: "site-footer",
};
